import { UserStatus } from '@vue-util/cookie';

export const getCustomerState = () => {
  if (UserStatus.isSignedIn()) {
    return 'SIGNED_IN';
  }
  // To check Soft SignedIn
  if (UserStatus.isSoftSignedIn()) {
    return 'RECOGNIZED';
  }
  return 'GUEST';
};

export default {
  getCustomerState,
};
